import { render, staticRenderFns } from "./SelectsComp.vue?vue&type=template&id=74105b10&"
import script from "./SelectsComp.vue?vue&type=script&lang=js&"
export * from "./SelectsComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports